module.exports = __webpack_public_path__ + "static/media/port2.bc183f68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/port2.jpg
// module id = 5836
// module chunks = 0